import React from "react";
import StartTrialBtn from "./StartTrialBtn";
import causalfunnel_impact from "../../assets/images/mains/Funnel with CF Impact.webp";

import calf_furn_store from "../../assets/images/companies/CaliforniaFurnitureStore.webp";
import edgemobilitysystem from "../../assets/images/companies/ems-logo.webp";
import rockwell from "../../assets/images/companies/Rockwell Razors Logo.svg";
import simplyShoes from "../../assets/images/companies/SimplyShoes Logo.webp";
import rightAngle from "../../assets/images/icons/rightAngle.svg";
import ReactPlayer from 'react-player/lazy'
const Conversion = ({ title, desc, type, videoURL }) => {
  const cast_studies = {
    ONE: {
      img: calf_furn_store,
      salesIncr: "200%",
      type: "Increase in conversion",
      name: "California Furniture",
      bgColor: "#ebfbff",
      url: "https://www.blog.causalfunnel.com/blogpost;id=CausalFunnel-doubled-the-conversion-for-the-California-Furniture-store",
    },
    TWO: {
      img: simplyShoes,
      salesIncr: "8X",
      type: "Increase in orders",
      name: "Simply Shoes",
      bgColor: "#ebfbff",
      url: "https://www.blog.causalfunnel.com/blogpost;id=CausalFunnel-increased-SimplyShoes-orders-by-8X",
    },
    THREE: {
      img: rockwell,
      salesIncr: "302%",
      type: "Increase in conversion",
      name: "Rockwell",
      bgColor: "#ebfbff",
      url: "https://www.blog.causalfunnel.com/blogpost;id=CausalFunnel-increased-Rockwell's-ads-revenue-by-302%25-with-Intent-Prediction",
    },
    FOUR: {
      img: edgemobilitysystem,
      salesIncr: "3.8X",
      type: "Increase in orders",
      name: "Edge-Mobility-System",
      bgColor: "#ebfbff",
      url: "https://www.blog.causalfunnel.com/blogpost;id=CausalFunnel-increased-orders-by-3.8X-for-EDGE-Mobility-System",
    },
  };
  return (
    <div className="conversion my-sm-5" id="caseStudies">
      <div className="container conversion-container">
        <div className="row conv-upper-container py-sm-5">
          <div
            className="col-12 col-md-6 convText"
            x-intersect="$el.classList.add('fadeInUp-parallax')"
          >
            <h2 >
              {title}
            </h2>
            <p >{desc}</p>
            <div
              className="mt-5"
              
            >
              <StartTrialBtn title="Start Free Trial" href="/free-trial" />
            </div>
          </div>
          <div className="col-12 col-md-6 mt-5 mt-md-0">
            <div className={type === "video" ? "d-none" : "hero-img-container"}>
              <img
                className="img-fluid"
                src={causalfunnel_impact}
                alt="person"
                
              />
            </div>
            <div
              className={
                type === "image" ? "d-none" : "causalfunnel-youtube-videos player-wrapper"
              }
            >
              <ReactPlayer
                url={videoURL}
                controls
                width="100%"
                height="100%"
                className='react-player'
                // light="true"
                playing="true"
                volume="0"
              />
            </div>
          </div>
        </div>
        <div className="row my-5">
          <div className="case-studies-container m-auto flex">
            <Studies
              icon={cast_studies.ONE.img}
              incrNo={cast_studies.ONE.salesIncr}
              categ={cast_studies.ONE.type}
              bg={cast_studies.ONE.bgColor}
              url={cast_studies.ONE.url}
              cls="california"
            />
            <Studies
              icon={cast_studies.TWO.img}
              incrNo={cast_studies.TWO.salesIncr}
              categ={cast_studies.TWO.type}
              bg={cast_studies.TWO.bgColor}
              url={cast_studies.TWO.url}
              cls="simplyshoes"
            />
            <Studies
              icon={cast_studies.THREE.img}
              incrNo={cast_studies.THREE.salesIncr}
              categ={cast_studies.THREE.type}
              bg={cast_studies.THREE.bgColor}
              url={cast_studies.THREE.url}
              cls="rockwell"
            />
            <Studies
              icon={cast_studies.FOUR.img}
              incrNo={cast_studies.FOUR.salesIncr}
              categ={cast_studies.FOUR.type}
              bg={cast_studies.FOUR.bgColor}
              url={cast_studies.FOUR.url}
              cls="edgemobilitiy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Conversion;

export const Studies = (props) => {
  const { icon, incrNo, categ, cls, bg, url } = props;
  return (
    <div
      className={`studies m-2 m-sm-3 ${cls} flex`}
      style={{ backgroundColor: bg }}
      onClick={() => (window.location.href = `${url}`)}
      x-intersect="$el.classList.add('scale-parallax')"
    >
      <div className="studies-img-container flex">
        <div className="std-cmp-logo">
          <img className="img-fluid" src={icon} alt="client company logo" />
        </div>
      </div>
      <div className="sales-boost flex-col">
        <h5>{incrNo}</h5>
        <p>{categ}</p>
      </div>
      <div className="my-auto flex">
        <div className="swipe-container flex">
          <img className="img-fluid" src={rightAngle} alt="right swipe icon" />
        </div>
      </div>
    </div>
  );
};
